import { useState } from 'react';

function signupErrorMessage(json) {
  if (json.error) {
    return json.error;
  }
  if (json.detail) {
    return Array.isArray(json.detail) ? json.detail.join(' ') : json.detail;
  }
  if (json.username) {
    const msg = json.username;
    return Array.isArray(msg) ? msg.join(' ') : msg;
  }
  return 'Signup failed. Please try again.';
}

export const useSignup = () => {
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const signup = async (email, password) => {
    setIsLoading(true);
    setError(null);

    try {
      const response = await fetch('/api/authenticate/users/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'omit',
        body: JSON.stringify({ username: email, password }),
      });

      const json = await response.json();

      if (!response.ok) {
        setError(signupErrorMessage(json));
        return;
      }
      setError(`Verification Email Sent on ${email}, Please Check your WebMail`);
    } catch (e) {
      setError('Something went wrong. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };
  return { signup, isLoading, error };
};
